"use strict";

function UserInputRepository(storage, Util) {
	// var userInput = {};

	function update(input) {
		var userInput = this.get();
		userInput = angular.extend(userInput, input);
		storage.setItem('userInput', userInput);
		// console.log(input);
	}

	function get(defaultData, dotSeperatedFieldPath) {
		defaultData = defaultData || {}
		var userInput = storage.getItem('userInput');
		userInput = Object.extend(defaultData, userInput);
		if (dotSeperatedFieldPath)
			return Util.findHierarchyStringInObject(userInput, dotSeperatedFieldPath, '.');

		return userInput;
	}

	return {
		update: update,
		get: get
	};
}
